<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-menu ref="datePickerMenu"
                v-model="datePickerMenuOpened"
                :close-on-content-click="false"
                transition="scale-transition"
                bottom>
          <template v-slot:activator="{on, attrs}">
            <v-text-field outlined
                          v-model="selectedMonth"
                          append-icon="mdi-calendar"
                          readonly
                          v-on="on"></v-text-field>
          </template>
          <v-date-picker type="month"
                         no-title
                         scrollable
                         v-model="selectedMonth"
                         @input="datePickerMenuOpened = false">
          </v-date-picker>
        </v-menu>

      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-calendar type="month"
                    :start="selectedMonthStart"
                    :end="selectedMonthEnd">
          <template v-slot:day="{date}">
            <v-row class="text-center">
              <v-col>
                <div v-if="calendar[date]">
                  <v-tooltip left offset-overflow content-class="tooltipWindow">
                    <template v-slot:activator="{ on }">
                      <v-btn text v-on="on" v-on:click="nameClicked(calendar[date])">{{ calendar[date].name }}</v-btn>
                    </template>
                    <DayScheduleTimeLine v-bind:value="JSON.parse(calendar[date].sessions) || []" :interval-height="24"></DayScheduleTimeLine>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>
          </template>
        </v-calendar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {computed, ref, watch} from '@vue/composition-api';
import {DateTime} from "luxon";
import DayScheduleTimeLine from "../../DayScheduleTimeline";

export default {
  name: 'ItemTypeCalendarView',
  components: {DayScheduleTimeLine},
  props: {
    typeId: String,
  },
  setup(props, {root}) {
    const datePickerMenuOpened = ref(false);
    const selectedMonth = ref(DateTime.fromJSDate(new Date()).toFormat('yyyy-MM'));
    const selectedMonthStart = computed(() => {
      return DateTime.fromISO(selectedMonth.value).startOf('month').toISODate();
    });
    const selectedMonthEnd = computed(() => {
      return DateTime.fromISO(selectedMonth.value).endOf('month').toISODate();
    });

    const calendar = ref({});
    const getDaySchedules = function () {
      root.$callAPI('room/admin/item_type/calendar/', {
        type_id: props.typeId,
        start: selectedMonthStart.value,
        end: selectedMonthEnd.value,
      }, function (response) {
        calendar.value = response.body.calendar;
      });
    };

    const nameClicked = function (data) {
      this.$parent.$parent.clickTab(this.$parent.$parent.getTabs()[2])
    }

    watch([selectedMonth], () => {
      getDaySchedules();
    }, {immediate: true});

    return {
      datePickerMenuOpened,
      selectedMonth,
      selectedMonthStart,
      selectedMonthEnd,
      calendar,
      nameClicked,
    }
  },
}
</script>

<style>
  .tooltipWindow {
    width: 600px;
  }
</style>
